import clsx from "clsx"
import classes from "./InputTopWithButtons.module.scss"
import { useRef } from "react"
import { useEffect } from "react"
import { useState } from "react"
import ButtonSend from "../ButtonSend"
import { motion } from "framer-motion"

const InputTopWithButtons = function InputWithButtons(props) {
    const { type = "text", className, onSubmit, onClick, onChange, previousAnswers, ...inputProps } = props
    const [hasAnswered, setHasAnswered] = useState(false);
    const [inputValue, setInputValue] = useState(previousAnswers == null ? '' : previousAnswers);
    const isInputEmpty = inputValue === '';
    const inputDisabled = previousAnswers != null;
    const inputRef = useRef();

    const onChangeHandler = (e) => {
        onChange(e);
        setInputValue(e.target.value.trim());
    }

    useEffect(() => {
        inputRef.current.focus();
    }, [])

    const onSubmitHandler = (e) => {
        e.preventDefault();
        if (hasAnswered) return;
        setHasAnswered(true);
        onSubmit(e);
    }

    return (
        <div className={clsx(classes.fullwidth, className)} onClick={onClick} style={{ pointerEvents: hasAnswered ? "auto" : "none" }}>
            <motion.div
                className={clsx(classes.inputWrapper)}
                initial={{ opacity: 0, y: "-100%" }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: 0.5 }}
            >
                <form onSubmit={onSubmitHandler} style={{ display: "contents" }} >
                    <input
                        className={classes.input}
                        name="options"
                        value={inputValue}
                        type={type}
                        ref={inputRef}
                        {...inputProps}
                        onChange={onChangeHandler}
                        disabled={inputDisabled}
                    />
                    <div className={classes.actions}>
                        <ButtonSend
                            disabled={isInputEmpty || inputDisabled}
                        />
                    </div>
                </form>
            </motion.div>
        </div>
    )
}

export default InputTopWithButtons